<script>
    import { onMount } from "svelte";

    import { createEventDispatcher } from "svelte";

    import Select from "svelte-select/Select.svelte";

    import CreateSurgeonModal from "../../../PatientEncounter/components/CreateSurgeonModal.svelte";

    import {
        user,
        loggedInDoctorDetail,
        accountDoctors,
    } from "../../../../stores";

    import { apiMethods } from "../../../../Services/index.svelte";

    import { getTitle } from "../../../../Utils/utilFunctions.svelte";

    import {
        CardLayout,
        Loader,
        DateInput,
    } from "../../../../Components/Common/index.svelte";

    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../PatientEncounter/helpers/encounterUtils.svelte";

    import { encounterBillingType } from "../../../../Utils/utilEnums.svelte";

    export let selectedSurgeon = {},
        patientEncounterDetails = {},
        selectedHospital = {},
        createSurgeonFilters,
        typeOfBill = Number(0),
        isCreate = false,
        overrideValidation = false;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (!$accountDoctors.length && !hasAccountDoctorsFetched)
        loadAccountDoctors();

    $: _syncSurgeonOptions($accountDoctors, suggestedAccountDoctors);

    let isCreateNewSurgeonModalOpen = false;

    let hasAccountDoctorsFetched = false,
        isLoadingAccountDoctors = false,
        hasSuggestedAccountDoctorsFetched = false,
        isLoadingSuggestedAccountDoctors = false,
        suggestedAccountDoctors = [];

    let hasSuggestedHospitalsFetched = false,
        isLoadingSuggestedHospitals = false,
        suggestedHospitals = [];

    let surgeonOptions = [],
        hospitalOptions = [];

    let errInputs = [];

    let minDate;

    // const btnOptions = [
    //     {
    //         iconName: "addIcon",
    //         iFont: "fa-solid fa-plus",
    //         btnText: "Add new surgeon/referrer",
    //         iconFunction: () => openCreateNewSurgeonModal(),
    //     },
    // ];

    onMount(() => {
        getMinDateForDatePicker();
    });

    const getMinDateForDatePicker = () => {
        const today = new Date();

        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();

        const isLastDayOfYear = month == 12 && day == 31;

        const isLastDayOfMonth = new Date(year, month, 0).getDate() === day;

        let tomorrow;

        if (!isLastDayOfMonth) tomorrow = new Date(year, month - 1, day + 1);
        else if (!isLastDayOfYear) tomorrow = new Date(year, month, 1);
        else tomorrow = new Date(year + 1, 0, 1);

        const tmrYear = tomorrow.getFullYear();
        const tmrMonth = tomorrow.getMonth() + 1;
        const tmrDay = tomorrow.getDate();

        minDate = `${tmrYear}-${tmrMonth}-${tmrDay}`;
    };

    export const checkProcedureDetailsValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const dispatch = createEventDispatcher();

    const loadAccountDoctors = async (replaceSelectedSurgeon = true) => {
        isLoadingAccountDoctors = true;

        const obj = {
            "filter[doctorId]": isFlowEnableSearchDoctor
                ? $loggedInDoctorDetail.id
                : $user.id,
        };

        await apiMethods.getMethod
            .getAccountDoctors(0, 999999, obj)
            .then((res) => {
                if (res.results) {
                    $accountDoctors = [...res.results];

                    if (replaceSelectedSurgeon) {
                        selectedSurgeon.details = $accountDoctors.find(
                            (s) => s.id == selectedSurgeon?.details?.id,
                        );
                        if (selectedSurgeon)
                            selectedSurgeon.matchingId = `${selectedSurgeon.id}${selectedSurgeon.state}`;
                    }
                }
            });

        hasAccountDoctorsFetched = true;

        isLoadingAccountDoctors = false;
    };

    const loadSuggestedAccountDoctors = async () => {
        if (suggestedAccountDoctors.length || hasSuggestedAccountDoctorsFetched)
            return;

        const doctorID = $loggedInDoctorDetail.id;

        if (!doctorID) return;

        isLoadingSuggestedAccountDoctors = true;

        await apiMethods.getMethod.getSuggestedSurgeon(doctorID).then((res) => {
            if (res.results) suggestedAccountDoctors = [...res.results];
        });

        //filter surgeons and take only once by unique id
        suggestedAccountDoctors = [
            ...new Map(suggestedAccountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (suggestedAccountDoctors.length > 5)
            suggestedAccountDoctors = suggestedAccountDoctors.slice(0, 5);

        hasSuggestedAccountDoctorsFetched = true; 

        isLoadingSuggestedAccountDoctors = false;
    };

    const loadSuggestedHospitals = async () => {
        if (
            suggestedHospitals.length ||
            hasSuggestedHospitalsFetched ||
            isLoadingSuggestedHospitals
        )
            return;

        const doctorID = $loggedInDoctorDetail.id;

        if (!doctorID) return;

        isLoadingSuggestedHospitals = true;

        await apiMethods.getMethod
            .getSuggestedHospital(doctorID)
            .then((res) => {
                if (res.results) {
                    suggestedHospitals = [...res.results];

                    const suggestedOptions = [];

                    suggestedHospitals.map((hospital) => {
                        suggestedOptions.push({
                            ...hospital,
                            groupName: "Suggested Hospitals",
                        });
                    });

                    hospitalOptions = [...suggestedOptions];
                }
            });

        hasSuggestedHospitalsFetched = true;

        isLoadingSuggestedHospitals = false;
    };

    const loadHospitals = async (searchText) => {
        const res = searchText
            ? await apiMethods.getMethod.getHospitals(0, 999999, {
                  search: searchText,
              })
            : await Promise.resolve([]);

        return _handleSearchHospitals(
            res.results?.length > 0 ? res.results : [],
        );
    };

    const groupBy = (option) => option.groupName;

    const getOptionLabelForSurgeon = ({
        firstName,
        lastName,
        title,
        speciality,
        state,
    }) =>
        `${getTitle(title)} ${firstName} ${lastName} ${
            state ? "- " + state.toUpperCase() + " -" : ""
        } (${speciality})`;

    const clearCurrentSurgeon = () => {
        selectedSurgeon = {};

        errInputs = removeErrorInput(
            "surgeonSelect",
            errInputs,
            "Surgeon/Referrer",
        );

        restSurgeonContainerStyle();
    };

    const onFocusSurgeonSelector = () => {
        loadSuggestedAccountDoctors();

        restSurgeonContainerStyle();
    };

    const restSurgeonContainerStyle = () => {
        const surgeonContainer = document.getElementById("surgeonContainer");
        surgeonContainer.style.outline = "";
    };

    const clearCurrentHospital = () => {
        selectedHospital.details = null;

        const hospitalContainer = document.getElementById("hospitalContainer");
        const hospitalSelect = document.getElementById("hospitalSelect");

        hospitalContainer.style.outline = "";
        hospitalSelect.placeholder = "Hospital";

        errInputs = removeErrorInput("hospitalSelect", errInputs, "Hospital");

        resetHospitalContainerStyle();

        loadHospitals();
    };

    const handleHospitalChange = () => {
        if (isCreate) dispatch("onHospitalChange", selectedHospital.details);
    };

    const onFocusHospitalSelector = async () => {
        resetHospitalContainerStyle();

        await loadSuggestedHospitals();
    };

    const resetHospitalContainerStyle = () => {
        const hospitalContainer = document.getElementById("hospitalContainer");
        hospitalContainer.style.outline = "";
    };

    const handleSelectOutsideHospital = () => {
        
        if (selectedHospital.details) clearCurrentHospital();
        else resetHospitalContainerStyle();
    };

    const openCreateNewSurgeonModal = () =>
        (isCreateNewSurgeonModalOpen = true);

    const closeCreateNewSurgeonModal = () =>
        (isCreateNewSurgeonModalOpen = false);

    // HELPER FUNCTIONS
    const _updateInvalidFieldsStyle = () => {
        if (!selectedSurgeon.details) {
            errInputs = addErrorInput(
                "surgeonSelect",
                errInputs,
                "Surgeon/Referrer",
            );

            const surgeonContainer =
                document.getElementById("surgeonContainer");
            surgeonContainer.style.outline = "red solid 2px";
            surgeonContainer.style.borderRadius = "5px";
        }

        if (
            (!selectedHospital || !selectedHospital.details) && !selectedHospital.outsideHospital &&
            !overrideValidation
        ) {
            errInputs = addErrorInput("hospitalSelect", errInputs, "Hospital");

            const hospitalContainer =
                document.getElementById("hospitalContainer");
            hospitalContainer.style.outline = "red solid 2px";
            hospitalContainer.style.borderRadius = "5px";
        }

        // allow create quote without date
        // if (!patientEncounterDetails.scheduledDate && !overrideValidation)
        //     errInputs = addErrorInput("scheduledDateField", errInputs);
        // else errInputs = removeErrorInput("scheduledDateField", errInputs);
    };

    const _syncSurgeonOptions = (
        accountDoctors = [],
        suggestedSurgeons = [],
    ) => {
        surgeonOptions = [];

        let uniqueAccountDoctors = [
            ...new Map(accountDoctors.map(doc => [doc.providerUniqueId, doc])).values()
        ];

        if (!suggestedSurgeons)
            uniqueAccountDoctors.map((doctor) => {
                surgeonOptions.push({
                    ...doctor,
                    displayLabel: getOptionLabelForSurgeon(doctor),
                });
            });
        else {
            const suggestedSurgeonUniqueIds = [];
            const len = Math.min(suggestedSurgeons.length, 5);

            for (let i = 0; i < len; i++) {
                const surgeon = suggestedSurgeons[i];

                surgeonOptions.push({
                    ...surgeon,
                    groupName: "Suggested surgeons",
                    displayLabel: getOptionLabelForSurgeon(surgeon),
                });

                suggestedSurgeonUniqueIds.push(surgeon.providerUniqueId);
            }

            uniqueAccountDoctors.map((surgeon) => {
                if (
                    !suggestedSurgeonUniqueIds.includes(
                        surgeon.providerUniqueId.toString(),
                    )
                )
                    surgeonOptions.push({
                        ...surgeon,
                        groupName: "Other Surgeons",
                        displayLabel: getOptionLabelForSurgeon(surgeon),
                    });
            });
        }
    };

    const _handleSearchHospitals = (res = []) => {
        hospitalOptions = [];

        if (!res.length && !suggestedHospitals.length) return [];

        const suggestedOptions = [];

        if (res.length) {
            hospitalOptions = [...res];
            return [...res];
        }

        if (!suggestedHospitals.length) return [];

        suggestedHospitals.map((hospital) => {
            suggestedOptions.push({
                ...hospital,
                groupName: "Suggested Hospitals",
            });
        });

        hospitalOptions = [...suggestedOptions];

        return [...suggestedOptions];
    };
</script>

<CardLayout title="Procedure Details" enableCollapse={false}>
    <div class="flex-1 p-4 gap-y-4 grid gap-x-0 xl:grid-cols-2 grid-cols-1">
        <div
            class="flex flex-col flex-1 justify-start gap-y-2 col-span-1 xl:pr-3 responsive-divider"
        >
            <div class="flex w-full items-center">
                <p class="title">Encounter Type:</p>
                <select
                    class="select flex-1 select-bordered select-sm"
                    bind:value={patientEncounterDetails.typeOfBill}
                >
                    {#each encounterBillingType as billingType}
                        <option value={billingType.id}>
                            {billingType.type}
                        </option>
                    {/each}
                </select>
            </div>

            <div class="flex w-full items-center">
                <p class="title">Procedure name:</p>
                <input
                    type="text"
                    id="procedureNameField"
                    placeholder="Procedure name"
                    class="input flex-1 input-sm input-bordered"
                    autocomplete="off"
                    bind:value={patientEncounterDetails.procedureName}
                />
            </div>

            <!-- surgeon/referrer -->
            <div class="flex flex-col flex-1 gap-y-2 w-full">
                <div class="flex flex-1 w-full items-center">
                    <p class="title">Surgeon / Referrer:</p>

                    {#if isLoadingAccountDoctors}
                        <div class="flex gap-x-2">
                            <p>Loading Surgeon/Referrer</p>
                            <Loader />
                        </div>
                    {:else}
                        <div class="w-remaining" id="surgeonContainer">
                            <Select
                                bind:value={selectedSurgeon.details}
                                id="surgeonSelect"
                                class="flex flex-1 max-h-[35px] rounded-full"
                                items={surgeonOptions}
                                itemId="id"
                                label="displayLabel"
                                {groupBy}
                                on:clear={clearCurrentSurgeon}
                                on:focus={onFocusSurgeonSelector}
                                noOptionsMessage="No surgeon/referrer found"
                                placeholder="Surgeon/Referrer"
                                --placeholder-color="#9CA3AF"
                                --height="32px"
                                --value-container-padding="0"
                                --padding="0 0 0 12px"
                                --font-size="14px"
                            />
                        </div>
                    {/if}
                </div>

                <div class="flex w-full items-center">
                    <p class="title" />

                    <div class="flex flex-1 w-full">
                        <p
                            class="underline cursor-pointer text-secondary"
                            on:click={openCreateNewSurgeonModal}
                        >
                            Add new surgeon/referrer
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="flex flex-col flex-1 gap-y-2 col-span-1 justify-start xl:pl-3"
        >
            <div class="flex w-full items-center">
                <p class="title">Procedure date:</p>
                <div class="flex flex-1 w-full">
                    <DateInput
                        bind:value={patientEncounterDetails.scheduledDate}
                        placeholder="Encounter Date"
                        id="scheduledDateField"
                        wrapperClass="input input-sm px-0 input-bordered w-full"
                        wrapperClassFocus="inputFocus"
                    />
                </div>
            </div>

            <div class="flex w-full items-center">
                <p class="title">Procedure time:</p>
                <input
                    bind:value={patientEncounterDetails.scheduledTime}
                    type="time"
                    class="input flex-1 input-sm input-bordered"
                    id="scheduledTimeField"
                />
            </div>

            <!-- Hospital -->
            <div class="flex flex-col flex-1 gap-y-2 w-full">
                <div class="flex flex-1 w-full items-center">
                    <p class="title">Hospital:</p>

                    <div class="w-remaining" id="hospitalContainer">
                        <Select
                            bind:value={selectedHospital.details}
                            id="hospitalSelect"
                            class="flex flex-1 max-h-[35px] rounded-full"
                            loadOptions={loadHospitals}
                            items={hospitalOptions}
                            {groupBy}
                            itemId="id"
                            label="name"
                            on:clear={clearCurrentHospital}
                            on:select={handleHospitalChange}
                            on:focus={onFocusHospitalSelector}
                            disabled={selectedHospital.outsideHospital}
                            noOptionsMessage="No hospital found"
                            placeholder="Hospital"
                            --placeholder-color="#9CA3AF"
                            --height="32px"
                            --value-container-padding="0"
                            --padding="0 0 0 12px"
                            --font-size="14px"
                        />
                    </div>
                </div>

                <div class="flex flex-1 w-full items-center">
                    <p class="title" />

                    <!-- outside hospital -->
                    <div class="flex items-center gap-x-2">
                        <input
                            type="checkbox"
                            id="outsideHospitalCheckbox"
                            class="toggle toggle-secondary"
                            autocomplete="off"
                            bind:checked={selectedHospital.outsideHospital}
                            on:change={handleSelectOutsideHospital}
                        />
                        <p class="font-bold">Outside Hospital</p>
                    </div>
                </div>
            </div>

            <!-- <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
                <p>Discharge date:</p>
                <div class="flex flex-c col-span-2">
                    <DateInput
                        bind:value={patientEncounterDetails.dischargeDate}
                        placeholder="Discharge Date"
                        id="dischargeDateField"
                        wrapperClass="input input-sm px-0 input-bordered w-full"
                        wrapperClassFocus="inputFocus"
                        minDate={patientEncounterDetails.scheduledDate}
                        isDisable={!UNLOCK_ALL_INPUTS &&
                            isEncounterHasActiveInvoice}
                    />
                </div>
            </div>

            <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
                <p>Discharge time:</p>
                <input
                    type="time"
                    class="input input-sm input-bordered col-span-2"
                    bind:value={patientEncounterDetails.dischargeTime}
                    disabled={!UNLOCK_ALL_INPUTS &&
                        isEncounterHasActiveInvoice}
                />
            </div> -->
        </div>
    </div>
</CardLayout>

<CreateSurgeonModal
    {isCreateNewSurgeonModalOpen}
    reloadSurgeonDetails={() => loadAccountDoctors(false)}
    closeFunc={closeCreateNewSurgeonModal}
    bind:filters={createSurgeonFilters}
    bind:selectedSurgeon={selectedSurgeon.details}
    doctorId={$loggedInDoctorDetail.id}
    existedOptions={surgeonOptions}
/>

<style>
    .title {
        width: 10rem;
    }

    @media (min-width: 1280px) {
        .responsive-divider {
            border-right: 2px solid #eaeaea;
        }
    }

    .responsive-divider {
        border-left: none;
    }

    .w-remaining {
        width: calc(100% - 160px);
    }
</style>
